import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import CustomSelect from '../../../ui/CustomSelect';

const RELATIONSHIP_OPTIONS = [
  { value: 'spouse', label: 'Suami/Istri' },
  { value: 'child', label: 'Anak' },
  { value: 'parent', label: 'Orang Tua' },
  { value: 'sibling', label: 'Saudara' },
];

const GENDER_OPTIONS = [
  { value: 'male', label: 'Laki-laki' },
  { value: 'female', label: 'Perempuan' },
];

export default function FamilyTab({ formData, setFormData }) {
  const addFamilyMember = () => {
    setFormData(prev => ({
      ...prev,
      family_members: [
        ...prev.family_members,
        {
          name: '',
          relationship: '',
          nik: '',
          birth_place: '',
          birth_date: '',
          gender: '',
          education: '',
        },
      ],
    }));
  };

  const updateFamilyMember = (index, field, value) => {
    const members = [...formData.family_members];
    members[index][field] = value;
    setFormData(prev => ({ ...prev, family_members: members }));
  };

  const removeFamilyMember = index => {
    setFormData(prev => ({
      ...prev,
      family_members: prev.family_members.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data Keluarga Inti</h3>
        <p className="text-gray-500 text-sm">Informasi anggota keluarga pegawai</p>
      </div>

      <AnimatePresence>
        {formData.family_members.map((member, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="border-2 rounded-lg p-4 space-y-3"
          >
            <div className="flex justify-between items-start">
              <h4 className="font-medium">Anggota Keluarga #{index + 1}</h4>
              <button
                type="button"
                onClick={() => removeFamilyMember(index)}
                className="text-red-500 hover:text-red-700 transition-colors duration-300"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
            <div className="grid md:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nama</label>
                <input
                  type="text"
                  value={member.name}
                  onChange={e => updateFamilyMember(index, 'name', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Hubungan</label>
                <CustomSelect
                  value={member.relationship}
                  onChange={v => updateFamilyMember(index, 'relationship', v)}
                  placeholder="Pilih"
                  width="w-full"
                  options={RELATIONSHIP_OPTIONS}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">NIK</label>
                <input
                  type="text"
                  value={member.nik}
                  onChange={e => {
                    // Only allow numeric input and limit to 16 digits
                    let value = e.target.value.replace(/\D/g, '');
                    if (value.length > 16) {
                      value = value.slice(0, 16);
                    }
                    updateFamilyMember(index, 'nik', value);
                  }}
                  placeholder="16 digit nomor"
                  maxLength={16}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent font-mono"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Jenis Kelamin
                </label>
                <CustomSelect
                  value={member.gender}
                  onChange={v => updateFamilyMember(index, 'gender', v)}
                  placeholder="Pilih"
                  width="w-full"
                  options={GENDER_OPTIONS}
                />
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>

      <motion.button
        type="button"
        onClick={addFamilyMember}
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.98 }}
        className="w-full py-2 border-2 border-dashed rounded-lg text-gray-600 hover:border-emerald-500 hover:text-emerald-600 hover:bg-emerald-50 flex items-center justify-center gap-2 transition-colors duration-300"
      >
        <Plus className="w-4 h-4" /> Tambah Anggota Keluarga
      </motion.button>
    </div>
  );
}
